import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
import './assets/main.scss'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import * as Sentry from '@sentry/vue'

const app = createApp(App)

Sentry.init({
  environment: import.meta.env.MODE,
  app,
  dsn: 'https://a88139ab12f5cb7223b8e9b07511e1bb@o4508131771613184.ingest.de.sentry.io/4508131773775952',
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration({
      networkDetailAllowUrls: [
        'https://tg-backend.leealabs.com',
        'https://staging.tg-backend.leealabs.com'
      ],
      networkRequestHeaders: ['Authorization']
    })
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})

const originalClear = localStorage.clear
const originalRemoveItem = localStorage.removeItem

localStorage.clear = function () {
  try {
    throw new Error('localStorage.clear() вызван')
  } catch (error) {
    console.error(error)
    Sentry.captureException(error)
  }
  // @ts-ignore
  // eslint-disable-next-line prefer-rest-params
  return originalClear.apply(this, arguments)
}

localStorage.removeItem = function (key) {
  try {
    throw new Error(`localStorage.removeItem() вызван для ключа: ${key}`)
  } catch (error) {
    console.error(error)
    Sentry.captureException(error)
  }
  // @ts-ignore
  // eslint-disable-next-line prefer-rest-params
  return originalRemoveItem.apply(this, arguments)
}

app.use(createPinia())
app.use(ElementPlus)
app.use(router)

app.mount('#app')
